"use client";

import useLocalStorage from "@/app/hooks/useLocalStorage";
import NumberTicker from "@/app/ui/magicui/number-ticker";
import { cn } from "@/lib/utils";

export default function Page() {
    const minClickGoal = 1000;
    const addEnemyClickEach_ms = 30 * 1000, enemyWeight = 40;
    const subscribeWeight = 20;
    const [enemyClicks, setEnemyClicks] = useLocalStorage<number>("eClicks", minClickGoal);
    const [myClicks, setMyClicks] = useLocalStorage<number>("mClicks", 0);
    const [timeClicks, setTimeClicks] = useLocalStorage<number>("tClicks", 0);

    const [flys, setFlys] = useState<FlyItem[]>([])

    const [initialSubCount, setInitialSubCount] = useLocalStorage<number>("initialSubCount", 0);
    const [subCount, setSubCount] = useLocalStorage<number>("subCount", 0);

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeClicks((JSON.parse(localStorage.tClicks).v || 0) + enemyWeight);
            setFlys(f => [...f, {
                "id": "x" + Math.random(),
                "text": `עוד ${enemyWeight} לפורטנייט`,
                className: "text-red-500  text-5xl"
            }])
        }, addEnemyClickEach_ms)
        return () => {
            clearInterval(interval);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const [isAnimating, setIsAnimating] = useState(false);

    useKey(" ", () => {
        setMyClicks((myClicks || 0) + 1)
        // Trigger animation
        setIsAnimating(true);

        setFlys(f => [...f, {
            "id": "x" + Math.random(),
            "text": `#טים_מיינקראפט`,
            className: "text-lime-400"
        }])

        // Remove animation class after animation ends (assuming animation duration is 500ms)
        setTimeout(() => {
            setIsAnimating(false);
        }, 200); // Match this duration to your Tailwind animation duration
    });

    useEffect(() => {
        const ws = new WebSocket("ws://localhost:11111/")
        ws.onerror = () => {
            alert("חיבור לסטרימר פלוס נכשל - יש לפתוח את התוכנה ולוודא שמחוברים למשתמש")
        }
        //on ws update subCount
        ws.onmessage = (msg: MessageEvent<string>) => {
            const current = JSON.parse(msg.data).SubCount;
            //save initial value
            if (initialSubCount == 0 || subCount == 0) {
                setInitialSubCount(current);
                setSubCount(current)
                return;
            }
            if (!subCount || !initialSubCount)
                return;

            //if unSub - ignore
            if (current <= subCount)
                return;

            setFlys(f => [...f, {
                "id": "x" + Math.random(),
                "text": `סאב חדש!  +${(current - subCount) * subscribeWeight} לפורטנייט`,
                className: "text-orange-400  text-3xl"
            }])

            //update
            setSubCount(current);
            setEnemyClicks(minClickGoal + (current - initialSubCount) * subscribeWeight)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    let enemyScore = Number(enemyClicks) + Number(timeClicks);
    let ProgressRatio_raw = Math.min(Number(myClicks) / enemyScore, 1)
    let ProgressRatio = Math.floor(ProgressRatio_raw * 200) / 2;

    useEffect(() => {
        if (ProgressRatio >= 100 && myClicks != 9999999999999999)
            setMyClicks(9999999999999999);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ProgressRatio])


    return <div className="relative overflow-hidden w-full h-full flex items-stretch justify-center flex-col">
        <div className="hidden text-red-500"></div>
        <div className="hidden text-orange-400  text-3xl"></div>
        <div className="hidden text-lime-400 text-5xl"></div>


        <div className={ cn("h-16 bg-red-500 relative rounded-md overflow-hidden mx-1 duration-200", isAnimating && "animate-in slide-in-from-bottom-1") }>
            <div className="h-16 bg-lime-500 absolute right-auto left-0 transition-all"
                style={ {
                    width: `${ProgressRatio}%`,
                    transitionDuration: "3s",
                    transitionTimingFunction: `cubic-bezier(0.33, ${ProgressRatio / 100 * 5}, 0.2, ${ProgressRatio / 100 * -5})`
                } }></div>
        </div>
        <div className="flex justify-between relative z-10 px-6 mt-2">
            <div className="flex flex-col gap-3 items-center">
                <NumberTicker value={ enemyScore } />
                <div className="flex flex-col items-center text-md">
                    <p>רשומים חדשים:</p>
                    <p>
                        { Number(subCount) - Number(initialSubCount) }x{ subscribeWeight } = <span className="text-red-400">+{ (Number(subCount) - Number(initialSubCount)) * subscribeWeight }</span>
                    </p>
                </div>
            </div>
            <span>{ myClicks }</span>
        </div>
        { flys.map(f => <FlyAlert key={ f.id } flyItem={ f } setFlys={ setFlys } />) }
    </div>
}

import { Dispatch, SetStateAction, useEffect, useState } from 'react';

function useKey(key: string, callback: (event: KeyboardEvent) => void): void {
    useEffect(() => {
        const handleKeyPress = (event: KeyboardEvent) => {
            if (event.key === key) {
                callback(event);
            }
        };

        window.addEventListener('keydown', handleKeyPress);

        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        };
    }, [key, callback]);
}

type FlyItem = {
    id: string;
    text: string;
    className: string
}

function FlyAlert({ flyItem, setFlys }: { flyItem: FlyItem, setFlys: Dispatch<SetStateAction<FlyItem[]>> }) {
    const [location, setLocation] = useState([Math.random(), Math.random()]);
    useEffect(() => {

        //set timout to remove the item
        const tout = setTimeout(() => {
            setFlys((pre) => pre.filter(item => item.id != flyItem.id));
        }, 1000)

        //on dismount clear timeout & attempt remove the item if possible
        return () => {
            clearTimeout(tout);
            setFlys((pre) => pre.filter(item => item.id != flyItem.id));
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return <div
        className={ cn("absolute rounded shadow-lg shadow-black border-2 border-current text-current px-2 py-3 overflow-hidden backdrop-blur-md",
            "animate-out slide-out-to-top-[100%] duration-1000 ease-in fill-mode-both",
            flyItem.className) + "  text-shadow-md text-shadow-black/60" }
        style={ {
            top: location[0] * 100 + "%",
            left: location[1] * 90 + "%"
        } }
    >
        <div className="bg-current absolute inset-0 opacity-20">
        </div>
        <span className="z-10 relative">{ flyItem.text }</span>
    </div>
}